import { companyToday } from './dateUtils';

// The palette the Google Sheet used, so the HRMS reads the same way to anyone
// migrating off it. Colour never carries meaning alone - the cell text always
// states the status, which also keeps this readable without colour vision.
const CELL_STYLES = [
  // A home day whose from-home request was rejected, or an office day whose office
  // confirmation is outstanding or refused. It sits above (late) because that part
  // is what still needs someone to act on it.
  [/\((unapproved|unconfirmed)/, 'bg-orange-100 text-orange-800'],
  // Matches "Home (late)" and the combined "Home (unapproved, late)".
  [/late\)/, 'bg-amber-100 text-amber-900'],
  [/^Absent/, 'bg-red-100 text-red-800'],
  [/^On leave|^OOO/, 'bg-gray-100 text-gray-700'],
  [/^Holiday/, 'bg-indigo-50 text-indigo-700'],
  [/^WFH!/, 'bg-orange-100 text-orange-800'],
  [/^Office/, 'bg-blue-100 text-blue-800'],
  [/^Home/, 'bg-green-100 text-green-800'],
  [/^Present/, 'bg-yellow-100 text-yellow-800'],
];

export const cellClass = (cell) => {
  const match = CELL_STYLES.find(([re]) => re.test(cell || ''));
  return match ? match[1] : 'bg-gray-100 text-gray-700';
};

export { EMPLOYMENT_TYPES } from '../constants';

// The company's current month first, then the ones before it. Built on UTC dates so the
// browser's zone cannot move a month.
export const monthOptions = (count = 12) => {
  const [year, month] = companyToday().split('-').map(Number);
  const out = [];
  for (let i = 0; i < count; i += 1) {
    const d = new Date(Date.UTC(year, month - 1 - i, 1));
    const value = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
    out.push({ value, label: d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' }) });
  }
  return out;
};
